import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=438c2932&"
import script from "./Glossary.vue?vue&type=script&lang=js&"
export * from "./Glossary.vue?vue&type=script&lang=js&"
import style0 from "./Glossary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports